import type { ReactNode } from 'react'

interface LayoutProps {
  children: ReactNode
  title?: string
  rightContent?: ReactNode
}

const Layout = ({ children, title = '電子カルテ', rightContent }: LayoutProps) => {
  return (
    <div className="min-h-screen bg-neutral-50">
      {/* タブレット最適化ヘッダー */}
      <header className="bg-primary text-white shadow-elevated sticky top-0 z-50">
        <div className="px-6 py-5 flex items-center justify-between">
          <h1 className="text-2xl md:text-3xl font-light tracking-wide">{title}</h1>
          {rightContent && <div className="flex-shrink-0">{rightContent}</div>}
        </div>
      </header>

      {/* メインコンテンツ */}
      <main>{children}</main>
    </div>
  )
}

export default Layout
